import { defineComponent } from "vue";
export default defineComponent({
    props: {
        active: {
            type: Boolean,
        },
    },
    computed: {
        colour: function () {
            return `background: ${this.active ? "#3bc14a" : "#d90429"};`;
        },
    },
});
